import React, { useEffect } from 'react'

import { AppAntSwitch } from '@components'
import { useAppFormHandler } from '@hooks'
import { useComputed } from '@preact/signals-react'
import { formData } from '@signals'


export default function IsCompanySelector() {

	const { showCompany, onShowCompanyChange } = useAppFormHandler('showCompany')
	const hasValues = useComputed(() => !formData.value?.companies)

	useEffect(() => {
		if(hasValues.value.length) onShowCompanyChange(true)
	}, [hasValues.value])


	return <AppAntSwitch
		falseText="User"
		trueText="Company"
		checked={!!showCompany}
		onChange={e => {
			onShowCompanyChange(e.target.checked)
		}}
	/>

}